/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $242210c2ae8f94f6$var$t = globalThis, $242210c2ae8f94f6$export$b4d10f6001c083c2 = $242210c2ae8f94f6$var$t.ShadowRoot && (void 0 === $242210c2ae8f94f6$var$t.ShadyCSS || $242210c2ae8f94f6$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $242210c2ae8f94f6$var$s = Symbol(), $242210c2ae8f94f6$var$o = new WeakMap;
class $242210c2ae8f94f6$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $242210c2ae8f94f6$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($242210c2ae8f94f6$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $242210c2ae8f94f6$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $242210c2ae8f94f6$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $242210c2ae8f94f6$export$8d80f9cac07cdb3 = (t)=>new $242210c2ae8f94f6$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $242210c2ae8f94f6$var$s), $242210c2ae8f94f6$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $242210c2ae8f94f6$export$505d1e8739bad805(o, t, $242210c2ae8f94f6$var$s);
}, $242210c2ae8f94f6$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($242210c2ae8f94f6$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $242210c2ae8f94f6$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $242210c2ae8f94f6$export$ee69dfd951e24778 = $242210c2ae8f94f6$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $242210c2ae8f94f6$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $5861e07b888ab170$var$i, defineProperty: $5861e07b888ab170$var$e, getOwnPropertyDescriptor: $5861e07b888ab170$var$h, getOwnPropertyNames: $5861e07b888ab170$var$r, getOwnPropertySymbols: $5861e07b888ab170$var$o, getPrototypeOf: $5861e07b888ab170$var$n } = Object, $5861e07b888ab170$var$a = globalThis, $5861e07b888ab170$var$c = $5861e07b888ab170$var$a.trustedTypes, $5861e07b888ab170$var$l = $5861e07b888ab170$var$c ? $5861e07b888ab170$var$c.emptyScript : "", $5861e07b888ab170$var$p = $5861e07b888ab170$var$a.reactiveElementPolyfillSupport, $5861e07b888ab170$var$d = (t, s)=>t, $5861e07b888ab170$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $5861e07b888ab170$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $5861e07b888ab170$export$53a6892c50694894 = (t, s)=>!$5861e07b888ab170$var$i(t, s), $5861e07b888ab170$var$b = {
    attribute: !0,
    type: String,
    converter: $5861e07b888ab170$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $5861e07b888ab170$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $5861e07b888ab170$var$a.litPropertyMetadata ??= new WeakMap;
class $5861e07b888ab170$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $5861e07b888ab170$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $5861e07b888ab170$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $5861e07b888ab170$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $5861e07b888ab170$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($5861e07b888ab170$var$d("elementProperties"))) return;
        const t = $5861e07b888ab170$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($5861e07b888ab170$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($5861e07b888ab170$var$d("properties"))) {
            const t = this.properties, s = [
                ...$5861e07b888ab170$var$r(t),
                ...$5861e07b888ab170$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $242210c2ae8f94f6$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $242210c2ae8f94f6$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $242210c2ae8f94f6$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $5861e07b888ab170$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $5861e07b888ab170$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $5861e07b888ab170$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$5861e07b888ab170$export$c7c07a37856565d.elementStyles = [], $5861e07b888ab170$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $5861e07b888ab170$export$c7c07a37856565d[$5861e07b888ab170$var$d("elementProperties")] = new Map, $5861e07b888ab170$export$c7c07a37856565d[$5861e07b888ab170$var$d("finalized")] = new Map, $5861e07b888ab170$var$p?.({
    ReactiveElement: $5861e07b888ab170$export$c7c07a37856565d
}), ($5861e07b888ab170$var$a.reactiveElementVersions ??= []).push("2.1.1");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8ca6ebe8d46dfd5b$var$t = globalThis, $8ca6ebe8d46dfd5b$var$i = $8ca6ebe8d46dfd5b$var$t.trustedTypes, $8ca6ebe8d46dfd5b$var$s = $8ca6ebe8d46dfd5b$var$i ? $8ca6ebe8d46dfd5b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $8ca6ebe8d46dfd5b$var$e = "$lit$", $8ca6ebe8d46dfd5b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $8ca6ebe8d46dfd5b$var$o = "?" + $8ca6ebe8d46dfd5b$var$h, $8ca6ebe8d46dfd5b$var$n = `<${$8ca6ebe8d46dfd5b$var$o}>`, $8ca6ebe8d46dfd5b$var$r = document, $8ca6ebe8d46dfd5b$var$l = ()=>$8ca6ebe8d46dfd5b$var$r.createComment(""), $8ca6ebe8d46dfd5b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $8ca6ebe8d46dfd5b$var$a = Array.isArray, $8ca6ebe8d46dfd5b$var$u = (t)=>$8ca6ebe8d46dfd5b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $8ca6ebe8d46dfd5b$var$d = "[ \t\n\f\r]", $8ca6ebe8d46dfd5b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $8ca6ebe8d46dfd5b$var$v = /-->/g, $8ca6ebe8d46dfd5b$var$_ = />/g, $8ca6ebe8d46dfd5b$var$m = RegExp(`>|${$8ca6ebe8d46dfd5b$var$d}(?:([^\\s"'>=/]+)(${$8ca6ebe8d46dfd5b$var$d}*=${$8ca6ebe8d46dfd5b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $8ca6ebe8d46dfd5b$var$p = /'/g, $8ca6ebe8d46dfd5b$var$g = /"/g, $8ca6ebe8d46dfd5b$var$$ = /^(?:script|style|textarea|title)$/i, $8ca6ebe8d46dfd5b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5 = $8ca6ebe8d46dfd5b$var$y(1), $8ca6ebe8d46dfd5b$export$7ed1367e7fa1ad68 = $8ca6ebe8d46dfd5b$var$y(2), $8ca6ebe8d46dfd5b$export$47d5b44d225be5b4 = $8ca6ebe8d46dfd5b$var$y(3), $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $8ca6ebe8d46dfd5b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $8ca6ebe8d46dfd5b$var$A = new WeakMap, $8ca6ebe8d46dfd5b$var$C = $8ca6ebe8d46dfd5b$var$r.createTreeWalker($8ca6ebe8d46dfd5b$var$r, 129);
function $8ca6ebe8d46dfd5b$var$P(t, i) {
    if (!$8ca6ebe8d46dfd5b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $8ca6ebe8d46dfd5b$var$s ? $8ca6ebe8d46dfd5b$var$s.createHTML(i) : i;
}
const $8ca6ebe8d46dfd5b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $8ca6ebe8d46dfd5b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $8ca6ebe8d46dfd5b$var$f ? "!--" === u[1] ? c = $8ca6ebe8d46dfd5b$var$v : void 0 !== u[1] ? c = $8ca6ebe8d46dfd5b$var$_ : void 0 !== u[2] ? ($8ca6ebe8d46dfd5b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $8ca6ebe8d46dfd5b$var$m) : void 0 !== u[3] && (c = $8ca6ebe8d46dfd5b$var$m) : c === $8ca6ebe8d46dfd5b$var$m ? ">" === u[0] ? (c = r ?? $8ca6ebe8d46dfd5b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $8ca6ebe8d46dfd5b$var$m : '"' === u[3] ? $8ca6ebe8d46dfd5b$var$g : $8ca6ebe8d46dfd5b$var$p) : c === $8ca6ebe8d46dfd5b$var$g || c === $8ca6ebe8d46dfd5b$var$p ? c = $8ca6ebe8d46dfd5b$var$m : c === $8ca6ebe8d46dfd5b$var$v || c === $8ca6ebe8d46dfd5b$var$_ ? c = $8ca6ebe8d46dfd5b$var$f : (c = $8ca6ebe8d46dfd5b$var$m, r = void 0);
        const x = c === $8ca6ebe8d46dfd5b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $8ca6ebe8d46dfd5b$var$f ? s + $8ca6ebe8d46dfd5b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $8ca6ebe8d46dfd5b$var$e + s.slice(d) + $8ca6ebe8d46dfd5b$var$h + x) : s + $8ca6ebe8d46dfd5b$var$h + (-2 === d ? i : x);
    }
    return [
        $8ca6ebe8d46dfd5b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $8ca6ebe8d46dfd5b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $8ca6ebe8d46dfd5b$var$V(t, s);
        if (this.el = $8ca6ebe8d46dfd5b$var$N.createElement(f, n), $8ca6ebe8d46dfd5b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $8ca6ebe8d46dfd5b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($8ca6ebe8d46dfd5b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($8ca6ebe8d46dfd5b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $8ca6ebe8d46dfd5b$var$H : "?" === e[1] ? $8ca6ebe8d46dfd5b$var$I : "@" === e[1] ? $8ca6ebe8d46dfd5b$var$L : $8ca6ebe8d46dfd5b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($8ca6ebe8d46dfd5b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($8ca6ebe8d46dfd5b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($8ca6ebe8d46dfd5b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $8ca6ebe8d46dfd5b$var$i ? $8ca6ebe8d46dfd5b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $8ca6ebe8d46dfd5b$var$l()), $8ca6ebe8d46dfd5b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $8ca6ebe8d46dfd5b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $8ca6ebe8d46dfd5b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($8ca6ebe8d46dfd5b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $8ca6ebe8d46dfd5b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $8ca6ebe8d46dfd5b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $8ca6ebe8d46dfd5b$var$S(t, i, s = t, e) {
    if (i === $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $8ca6ebe8d46dfd5b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $8ca6ebe8d46dfd5b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $8ca6ebe8d46dfd5b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $8ca6ebe8d46dfd5b$var$r).importNode(i, !0);
        $8ca6ebe8d46dfd5b$var$C.currentNode = e;
        let h = $8ca6ebe8d46dfd5b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $8ca6ebe8d46dfd5b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $8ca6ebe8d46dfd5b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $8ca6ebe8d46dfd5b$var$C.nextNode(), o++);
        }
        return $8ca6ebe8d46dfd5b$var$C.currentNode = $8ca6ebe8d46dfd5b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $8ca6ebe8d46dfd5b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $8ca6ebe8d46dfd5b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $8ca6ebe8d46dfd5b$var$S(this, t, i), $8ca6ebe8d46dfd5b$var$c(t) ? t === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee && this._$AR(), this._$AH = $8ca6ebe8d46dfd5b$export$45b790e32b2810ee) : t !== this._$AH && t !== $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $8ca6ebe8d46dfd5b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee && $8ca6ebe8d46dfd5b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($8ca6ebe8d46dfd5b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $8ca6ebe8d46dfd5b$var$N.createElement($8ca6ebe8d46dfd5b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $8ca6ebe8d46dfd5b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $8ca6ebe8d46dfd5b$var$A.get(t.strings);
        return void 0 === i && $8ca6ebe8d46dfd5b$var$A.set(t.strings, i = new $8ca6ebe8d46dfd5b$var$N(t)), i;
    }
    k(t) {
        $8ca6ebe8d46dfd5b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $8ca6ebe8d46dfd5b$var$R(this.O($8ca6ebe8d46dfd5b$var$l()), this.O($8ca6ebe8d46dfd5b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $8ca6ebe8d46dfd5b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $8ca6ebe8d46dfd5b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $8ca6ebe8d46dfd5b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $8ca6ebe8d46dfd5b$var$S(this, t, i, 0), o = !$8ca6ebe8d46dfd5b$var$c(t) || t !== this._$AH && t !== $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $8ca6ebe8d46dfd5b$var$S(this, e[s + n], i, n), r === $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$8ca6ebe8d46dfd5b$var$c(r) || r !== this._$AH[n], r === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee ? t = $8ca6ebe8d46dfd5b$export$45b790e32b2810ee : t !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $8ca6ebe8d46dfd5b$var$H extends $8ca6ebe8d46dfd5b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $8ca6ebe8d46dfd5b$var$I extends $8ca6ebe8d46dfd5b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee);
    }
}
class $8ca6ebe8d46dfd5b$var$L extends $8ca6ebe8d46dfd5b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $8ca6ebe8d46dfd5b$var$S(this, t, i, 0) ?? $8ca6ebe8d46dfd5b$export$45b790e32b2810ee) === $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee && s !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $8ca6ebe8d46dfd5b$export$45b790e32b2810ee && (s === $8ca6ebe8d46dfd5b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $8ca6ebe8d46dfd5b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $8ca6ebe8d46dfd5b$var$S(this, t);
    }
}
const $8ca6ebe8d46dfd5b$export$8613d1ca9052b22e = {
    M: $8ca6ebe8d46dfd5b$var$e,
    P: $8ca6ebe8d46dfd5b$var$h,
    A: $8ca6ebe8d46dfd5b$var$o,
    C: 1,
    L: $8ca6ebe8d46dfd5b$var$V,
    R: $8ca6ebe8d46dfd5b$var$M,
    D: $8ca6ebe8d46dfd5b$var$u,
    V: $8ca6ebe8d46dfd5b$var$S,
    I: $8ca6ebe8d46dfd5b$var$R,
    H: $8ca6ebe8d46dfd5b$var$k,
    N: $8ca6ebe8d46dfd5b$var$I,
    U: $8ca6ebe8d46dfd5b$var$L,
    B: $8ca6ebe8d46dfd5b$var$H,
    F: $8ca6ebe8d46dfd5b$var$z
}, $8ca6ebe8d46dfd5b$var$j = $8ca6ebe8d46dfd5b$var$t.litHtmlPolyfillSupport;
$8ca6ebe8d46dfd5b$var$j?.($8ca6ebe8d46dfd5b$var$N, $8ca6ebe8d46dfd5b$var$R), ($8ca6ebe8d46dfd5b$var$t.litHtmlVersions ??= []).push("3.3.1");
const $8ca6ebe8d46dfd5b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $8ca6ebe8d46dfd5b$var$R(i.insertBefore($8ca6ebe8d46dfd5b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3209565c87346803$var$s = globalThis;
class $3209565c87346803$export$3f2f9f5909897157 extends (0, $5861e07b888ab170$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $8ca6ebe8d46dfd5b$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8;
    }
}
$3209565c87346803$export$3f2f9f5909897157._$litElement$ = !0, $3209565c87346803$export$3f2f9f5909897157["finalized"] = !0, $3209565c87346803$var$s.litElementHydrateSupport?.({
    LitElement: $3209565c87346803$export$3f2f9f5909897157
});
const $3209565c87346803$var$o = $3209565c87346803$var$s.litElementPolyfillSupport;
$3209565c87346803$var$o?.({
    LitElement: $3209565c87346803$export$3f2f9f5909897157
});
const $3209565c87346803$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($3209565c87346803$var$s.litElementVersions ??= []).push("4.2.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c1d28c2e4fa3b004$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $65c13613f7024f62$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0c8d6c23f421d782$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $5861e07b888ab170$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $5861e07b888ab170$export$53a6892c50694894)
}, $0c8d6c23f421d782$export$8d623b1670eb40f4 = (t = $0c8d6c23f421d782$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $0c8d6c23f421d782$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $0c8d6c23f421d782$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3bd90e28f73d76df$export$ca000e230c0caa3e(r) {
    return (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9bc19aa60b98d033$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $146305b547e8cde0$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e95fa7940ac4d749$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $146305b547e8cde0$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $146305b547e8cde0$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $d9f4595569ebe604$var$e;
function $d9f4595569ebe604$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $146305b547e8cde0$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($d9f4595569ebe604$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $2463eb69a4aed891$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $146305b547e8cde0$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7cd30f9cbd25eeed$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $146305b547e8cde0$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $bc7c0dc49c93db5e$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $146305b547e8cde0$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b21739933ed75606$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $b21739933ed75606$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $b21739933ed75606$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $65c7cf7ae42ed665$export$3bebd1f0e3943985 extends (0, $b21739933ed75606$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $8ca6ebe8d46dfd5b$export$45b790e32b2810ee), i.type !== (0, $b21739933ed75606$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $8ca6ebe8d46dfd5b$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$65c7cf7ae42ed665$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $65c7cf7ae42ed665$export$3bebd1f0e3943985.resultType = 1;
const $65c7cf7ae42ed665$export$b6e69390c23686fb = (0, $b21739933ed75606$export$99b43ad1ed32e735)($65c7cf7ae42ed665$export$3bebd1f0e3943985);



// src/internal/closeActiveElement.ts
var $5dc3a705384ed2e2$export$7868286b01c1cec2 = (elm)=>{
    var _a;
    const { activeElement: activeElement } = document;
    if (activeElement && elm.contains(activeElement)) (_a = document.activeElement) == null || _a.blur();
};


// src/components/icon-button/icon-button.styles.ts

var $3f4470f81bc0b814$export$e7174f10cedebf49 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    color: var(--sl-color-neutral-600);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--sl-border-radius-medium);
    font-size: inherit;
    color: inherit;
    padding: var(--sl-spacing-x-small);
    cursor: pointer;
    transition: var(--sl-transition-x-fast) color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--sl-color-primary-600);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: var(--sl-color-primary-700);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;


// src/utilities/base-path.ts
var $7e748ac2c9ee78c8$var$basePath = "";
function $7e748ac2c9ee78c8$export$784ad41d332938c6(path) {
    $7e748ac2c9ee78c8$var$basePath = path;
}
function $7e748ac2c9ee78c8$export$9099264ed9b1c55a(subpath = "") {
    if (!$7e748ac2c9ee78c8$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $7e748ac2c9ee78c8$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $7e748ac2c9ee78c8$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $7e748ac2c9ee78c8$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


// src/components/icon/library.default.ts
var $e980b97cd14548de$var$library = {
    name: "default",
    resolver: (name)=>(0, $7e748ac2c9ee78c8$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $e980b97cd14548de$export$761783e099ce3526 = $e980b97cd14548de$var$library;


// src/components/icon/library.system.ts
var $0bae15c38e56eaf9$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $0bae15c38e56eaf9$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $0bae15c38e56eaf9$var$icons) return `data:image/svg+xml,${encodeURIComponent($0bae15c38e56eaf9$var$icons[name])}`;
        return "";
    }
};
var $0bae15c38e56eaf9$export$3139252f9828970f = $0bae15c38e56eaf9$var$systemLibrary;


// src/components/icon/library.ts
var $e46fbc9fac217803$var$registry = [
    (0, $e980b97cd14548de$export$761783e099ce3526),
    (0, $0bae15c38e56eaf9$export$3139252f9828970f)
];
var $e46fbc9fac217803$var$watchedIcons = [];
function $e46fbc9fac217803$export$da63f424a7208010(icon) {
    $e46fbc9fac217803$var$watchedIcons.push(icon);
}
function $e46fbc9fac217803$export$9e46b25ecab82f0b(icon) {
    $e46fbc9fac217803$var$watchedIcons = $e46fbc9fac217803$var$watchedIcons.filter((el)=>el !== icon);
}
function $e46fbc9fac217803$export$be026de5111f322b(name) {
    return $e46fbc9fac217803$var$registry.find((lib)=>lib.name === name);
}
function $e46fbc9fac217803$export$a482e04ad60c9b11(name, options) {
    $e46fbc9fac217803$export$8faa256e94012669(name);
    $e46fbc9fac217803$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $e46fbc9fac217803$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $e46fbc9fac217803$export$8faa256e94012669(name) {
    $e46fbc9fac217803$var$registry = $e46fbc9fac217803$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/icon/icon.styles.ts

var $be3339de16df5a90$export$f0b0874d64866432 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;


var $0601f050124ece31$var$__defProp = Object.defineProperty;
var $0601f050124ece31$var$__defProps = Object.defineProperties;
var $0601f050124ece31$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0601f050124ece31$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0601f050124ece31$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0601f050124ece31$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0601f050124ece31$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0601f050124ece31$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $0601f050124ece31$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $0601f050124ece31$var$__defNormalProp = (obj, key, value)=>key in obj ? $0601f050124ece31$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0601f050124ece31$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($0601f050124ece31$var$__hasOwnProp.call(b, prop)) $0601f050124ece31$var$__defNormalProp(a, prop, b[prop]);
    if ($0601f050124ece31$var$__getOwnPropSymbols) {
        for (var prop of $0601f050124ece31$var$__getOwnPropSymbols(b))if ($0601f050124ece31$var$__propIsEnum.call(b, prop)) $0601f050124ece31$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0601f050124ece31$export$f4da8f157c1253f7 = (a, b)=>$0601f050124ece31$var$__defProps(a, $0601f050124ece31$var$__getOwnPropDescs(b));
var $0601f050124ece31$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $0601f050124ece31$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $0601f050124ece31$var$__defProp(target, key, result);
    return result;
};
var $0601f050124ece31$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $0601f050124ece31$var$__typeError("Cannot " + msg);
var $0601f050124ece31$export$18a094aefa070634 = (obj, member, getter)=>($0601f050124ece31$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $0601f050124ece31$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $0601f050124ece31$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $0601f050124ece31$export$42432efe6614d3b4 = (obj, member, value, setter)=>($0601f050124ece31$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $0601f050124ece31$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $0601f050124ece31$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$0601f050124ece31$var$__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
    if (obj == null) {
        obj = value[$0601f050124ece31$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $0601f050124ece31$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) $0601f050124ece31$var$__typeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$0601f050124ece31$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};


// src/internal/watch.ts
function $350307ebc9093410$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $0601f050124ece31$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}


// src/styles/component.styles.ts

var $264a52ab16055a3e$export$e1ac0a3ec62d1269 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;





var $cac6099631212a0e$var$_hasRecordedInitialProperties;
var $cac6099631212a0e$export$6f25236e887097b = class extends (0, $3209565c87346803$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $0601f050124ece31$export$addf369becd23283)(this, $cac6099631212a0e$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $0601f050124ece31$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $0601f050124ece31$export$18a094aefa070634)(this, $cac6099631212a0e$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $0601f050124ece31$export$42432efe6614d3b4)(this, $cac6099631212a0e$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$cac6099631212a0e$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$cac6099631212a0e$export$6f25236e887097b.version = "2.20.1";
$cac6099631212a0e$export$6f25236e887097b.dependencies = {};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $cac6099631212a0e$export$6f25236e887097b.prototype, "dir", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $cac6099631212a0e$export$6f25236e887097b.prototype, "lang", 2);





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $a4dbc275fd3b7fe1$var$t } = (0, $8ca6ebe8d46dfd5b$export$8613d1ca9052b22e), $a4dbc275fd3b7fe1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $a4dbc275fd3b7fe1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $a4dbc275fd3b7fe1$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $a4dbc275fd3b7fe1$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $a4dbc275fd3b7fe1$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $a4dbc275fd3b7fe1$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $a4dbc275fd3b7fe1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $a4dbc275fd3b7fe1$var$r = ()=>document.createComment(""), $a4dbc275fd3b7fe1$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($a4dbc275fd3b7fe1$var$r(), l), d = e.insertBefore($a4dbc275fd3b7fe1$var$r(), l);
        n = new $a4dbc275fd3b7fe1$var$t(i, d, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, d = i !== o;
        if (d) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || d) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $a4dbc275fd3b7fe1$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $a4dbc275fd3b7fe1$var$u = {}, $a4dbc275fd3b7fe1$export$ea70d9dd5965b1c8 = (o, t = $a4dbc275fd3b7fe1$var$u)=>o._$AH = t, $a4dbc275fd3b7fe1$export$59e9bce518cde500 = (o)=>o._$AH, $a4dbc275fd3b7fe1$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $a4dbc275fd3b7fe1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $9bfb3a1601ca18a8$var$CACHEABLE_ERROR = Symbol();
var $9bfb3a1601ca18a8$var$RETRYABLE_ERROR = Symbol();
var $9bfb3a1601ca18a8$var$parser;
var $9bfb3a1601ca18a8$var$iconCache = /* @__PURE__ */ new Map();
var $9bfb3a1601ca18a8$export$ef62a86bf282441 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) {
            this.svg = (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $9bfb3a1601ca18a8$var$CACHEABLE_ERROR : $9bfb3a1601ca18a8$var$RETRYABLE_ERROR;
        } catch (e) {
            return $9bfb3a1601ca18a8$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $9bfb3a1601ca18a8$var$CACHEABLE_ERROR;
            if (!$9bfb3a1601ca18a8$var$parser) $9bfb3a1601ca18a8$var$parser = new DOMParser();
            const doc = $9bfb3a1601ca18a8$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $9bfb3a1601ca18a8$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $9bfb3a1601ca18a8$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $e46fbc9fac217803$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $e46fbc9fac217803$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $e46fbc9fac217803$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $e46fbc9fac217803$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $9bfb3a1601ca18a8$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $9bfb3a1601ca18a8$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $9bfb3a1601ca18a8$var$RETRYABLE_ERROR) $9bfb3a1601ca18a8$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $a4dbc275fd3b7fe1$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            if (library) {
                await this.updateComplete;
                const shadowSVG = this.shadowRoot.querySelector("[part='svg']");
                if (typeof library.mutator === "function" && shadowSVG) library.mutator(shadowSVG);
            }
            return;
        }
        switch(svg){
            case $9bfb3a1601ca18a8$var$RETRYABLE_ERROR:
            case $9bfb3a1601ca18a8$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$9bfb3a1601ca18a8$export$ef62a86bf282441.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $be3339de16df5a90$export$f0b0874d64866432)
];
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "svg", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "name", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "src", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "label", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "library", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("label")
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $9bfb3a1601ca18a8$export$ef62a86bf282441.prototype, "setIcon", 1);







/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $656efc25cab08857$export$56cc687933817664 = (0, $b21739933ed75606$export$99b43ad1ed32e735)(class extends (0, $b21739933ed75606$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $b21739933ed75606$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8;
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $83633668d38fc0ea$var$a = Symbol.for(""), $83633668d38fc0ea$var$o = (t)=>{
    if (t?.r === $83633668d38fc0ea$var$a) return t?._$litStatic$;
}, $83633668d38fc0ea$export$4b395f4b8c9b548e = (t)=>({
        _$litStatic$: t,
        r: $83633668d38fc0ea$var$a
    }), $83633668d38fc0ea$export$c8ec6e1ec9fefcb0 = (t, ...r)=>({
        _$litStatic$: r.reduce((r, e, a)=>r + ((t)=>{
                if (void 0 !== t._$litStatic$) return t._$litStatic$;
                throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`);
            })(e) + t[a + 1], t[0]),
        r: $83633668d38fc0ea$var$a
    }), $83633668d38fc0ea$var$l = new Map, $83633668d38fc0ea$export$878791788f808fc0 = (t)=>(r, ...e)=>{
        const a = e.length;
        let s, i;
        const n = [], u = [];
        let c, $ = 0, f = !1;
        for(; $ < a;){
            for(c = r[$]; $ < a && void 0 !== (i = e[$], s = $83633668d38fc0ea$var$o(i));)c += s + r[++$], f = !0;
            $ !== a && u.push(i), n.push(c), $++;
        }
        if ($ === a && n.push(r[a]), f) {
            const t = n.join("$$lit$$");
            void 0 === (r = $83633668d38fc0ea$var$l.get(t)) && (n.raw = n, $83633668d38fc0ea$var$l.set(t, r = n)), e = u;
        }
        return t(r, ...e);
    }, $83633668d38fc0ea$export$c0bb0b647f701bb5 = $83633668d38fc0ea$export$878791788f808fc0((0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)), $83633668d38fc0ea$export$7ed1367e7fa1ad68 = $83633668d38fc0ea$export$878791788f808fc0((0, $8ca6ebe8d46dfd5b$export$7ed1367e7fa1ad68)), $83633668d38fc0ea$export$47d5b44d225be5b4 = $83633668d38fc0ea$export$878791788f808fc0((0, $8ca6ebe8d46dfd5b$export$47d5b44d225be5b4));





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a2e23e237c51b1eb$export$f68dd208b5df064d = (o)=>o ?? (0, $8ca6ebe8d46dfd5b$export$45b790e32b2810ee);





var $f14a2a9dc31f5c78$export$302c9d29315a4659 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasFocus = false;
        this.label = "";
        this.disabled = false;
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    /** Simulates a click on the icon button. */ click() {
        this.button.click();
    }
    /** Sets focus on the icon button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the icon button. */ blur() {
        this.button.blur();
    }
    render() {
        const isLink = this.href ? true : false;
        const tag = isLink ? (0, $83633668d38fc0ea$export$c8ec6e1ec9fefcb0)`a` : (0, $83633668d38fc0ea$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $83633668d38fc0ea$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $656efc25cab08857$export$56cc687933817664)({
            "icon-button": true,
            "icon-button--disabled": !isLink && this.disabled,
            "icon-button--focused": this.hasFocus
        })}
        ?disabled=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        href=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.href : void 0)}
        target=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink && this.target ? "noreferrer noopener" : void 0)}
        role=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label="${this.label}"
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <sl-icon
          class="icon-button__icon"
          name=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.name)}
          library=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.library)}
          src=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.src)}
          aria-hidden="true"
        ></sl-icon>
      </${tag}>
    `;
    }
};
$f14a2a9dc31f5c78$export$302c9d29315a4659.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $3f4470f81bc0b814$export$e7174f10cedebf49)
];
$f14a2a9dc31f5c78$export$302c9d29315a4659.dependencies = {
    "sl-icon": (0, $9bfb3a1601ca18a8$export$ef62a86bf282441)
};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".icon-button")
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "button", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "hasFocus", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "name", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "library", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "src", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "href", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "target", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "download", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "label", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $f14a2a9dc31f5c78$export$302c9d29315a4659.prototype, "disabled", 2);



// src/utilities/animation-registry.ts
var $b575ae609e04e2cb$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $b575ae609e04e2cb$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $b575ae609e04e2cb$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $b575ae609e04e2cb$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $b575ae609e04e2cb$export$6e92ecdbe15fda0b(animationName, animation) {
    $b575ae609e04e2cb$var$defaultAnimationRegistry.set(animationName, $b575ae609e04e2cb$var$ensureAnimation(animation));
}
function $b575ae609e04e2cb$export$ea45326d94a48a31(el, animationName, animation) {
    $b575ae609e04e2cb$var$customAnimationRegistry.set(el, (0, $0601f050124ece31$export$f4da8f157c1253f7)((0, $0601f050124ece31$export$7de063a7aa429f6c)({}, $b575ae609e04e2cb$var$customAnimationRegistry.get(el)), {
        [animationName]: $b575ae609e04e2cb$var$ensureAnimation(animation)
    }));
}
function $b575ae609e04e2cb$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $b575ae609e04e2cb$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $b575ae609e04e2cb$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $b575ae609e04e2cb$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $b575ae609e04e2cb$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $0d375bcca7290bcb$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $e626354a2a01d7d8$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $0601f050124ece31$export$f4da8f157c1253f7)((0, $0601f050124ece31$export$7de063a7aa429f6c)({}, options), {
            duration: $e626354a2a01d7d8$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $e626354a2a01d7d8$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $e626354a2a01d7d8$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $e626354a2a01d7d8$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            animation.cancel();
            requestAnimationFrame(resolve);
        });
    }));
}
function $e626354a2a01d7d8$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $0601f050124ece31$export$f4da8f157c1253f7)((0, $0601f050124ece31$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}


// src/internal/slot.ts
var $b1a011109453a5c6$export$34f6a5ffaa663541 = class {
    constructor(host, ...slotNames){
        this.slotNames = [];
        this.handleSlotChange = (event)=>{
            const slot = event.target;
            if (this.slotNames.includes("[default]") && !slot.name || slot.name && this.slotNames.includes(slot.name)) this.host.requestUpdate();
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hasDefaultSlot() {
        return [
            ...this.host.childNodes
        ].some((node)=>{
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") return true;
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                const tagName = el.tagName.toLowerCase();
                if (tagName === "sl-visually-hidden") return false;
                if (!el.hasAttribute("slot")) return true;
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    test(slotName) {
        return slotName === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(slotName);
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener("slotchange", this.handleSlotChange);
    }
};
function $b1a011109453a5c6$export$132e79e4118a78e0(slot) {
    if (!slot) return "";
    const nodes = slot.assignedNodes({
        flatten: true
    });
    let text = "";
    [
        ...nodes
    ].forEach((node)=>{
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
    });
    return text;
}


// src/translations/en.ts
const $2550f5410d141525$var$connectedElements = new Set();
const $2550f5410d141525$var$translations = new Map();
let $2550f5410d141525$var$fallback;
let $2550f5410d141525$var$documentDirection = 'ltr';
let $2550f5410d141525$var$documentLanguage = 'en';
const $2550f5410d141525$var$isClient = typeof MutationObserver !== "undefined" && typeof document !== "undefined" && typeof document.documentElement !== "undefined";
if ($2550f5410d141525$var$isClient) {
    const documentElementObserver = new MutationObserver($2550f5410d141525$export$722fbec263ad908a);
    $2550f5410d141525$var$documentDirection = document.documentElement.dir || 'ltr';
    $2550f5410d141525$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            'dir',
            'lang'
        ]
    });
}
function $2550f5410d141525$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($2550f5410d141525$var$translations.has(code)) $2550f5410d141525$var$translations.set(code, Object.assign(Object.assign({}, $2550f5410d141525$var$translations.get(code)), t));
        else $2550f5410d141525$var$translations.set(code, t);
        if (!$2550f5410d141525$var$fallback) $2550f5410d141525$var$fallback = t;
    });
    $2550f5410d141525$export$722fbec263ad908a();
}
function $2550f5410d141525$export$722fbec263ad908a() {
    if ($2550f5410d141525$var$isClient) {
        $2550f5410d141525$var$documentDirection = document.documentElement.dir || 'ltr';
        $2550f5410d141525$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$2550f5410d141525$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === 'function') el.requestUpdate();
    });
}
class $2550f5410d141525$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $2550f5410d141525$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $2550f5410d141525$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $2550f5410d141525$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $2550f5410d141525$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        const locale = new Intl.Locale(lang.replace(/_/g, '-'));
        const language = locale === null || locale === void 0 ? void 0 : locale.language.toLowerCase();
        const region = (_b = (_a = locale === null || locale === void 0 ? void 0 : locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const primary = $2550f5410d141525$var$translations.get(`${language}-${region}`);
        const secondary = $2550f5410d141525$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $2550f5410d141525$var$fallback && $2550f5410d141525$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($2550f5410d141525$var$fallback && $2550f5410d141525$var$fallback[key]) term = $2550f5410d141525$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === 'function') return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? '' : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $ac943ac482ec0ba6$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $2550f5410d141525$export$2332cb3ce32cc839)($ac943ac482ec0ba6$var$translation);
var $ac943ac482ec0ba6$export$802b895dc4aecf21 = $ac943ac482ec0ba6$var$translation;



var $10722e07903896cc$export$b1a2fed5bb41b893 = class extends (0, $2550f5410d141525$export$b1a2fed5bb41b893) {
};
(0, $2550f5410d141525$export$2332cb3ce32cc839)((0, $ac943ac482ec0ba6$export$802b895dc4aecf21));


// src/components/alert/alert.styles.ts

var $f180a0188ba4af37$export$1b79454e98b5adc7 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: contents;

    /* For better DX, we'll reset the margin here so the base part can inherit it */
    margin: 0;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: stretch;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-top-width: calc(var(--sl-panel-border-width) * 3);
    border-radius: var(--sl-border-radius-medium);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-small);
    font-weight: var(--sl-font-weight-normal);
    line-height: 1.6;
    color: var(--sl-color-neutral-700);
    margin: inherit;
    overflow: hidden;
  }

  .alert:not(.alert--has-icon) .alert__icon,
  .alert:not(.alert--closable) .alert__close-button {
    display: none;
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-large);
    padding-inline-start: var(--sl-spacing-large);
  }

  .alert--has-countdown {
    border-bottom: none;
  }

  .alert--primary {
    border-top-color: var(--sl-color-primary-600);
  }

  .alert--primary .alert__icon {
    color: var(--sl-color-primary-600);
  }

  .alert--success {
    border-top-color: var(--sl-color-success-600);
  }

  .alert--success .alert__icon {
    color: var(--sl-color-success-600);
  }

  .alert--neutral {
    border-top-color: var(--sl-color-neutral-600);
  }

  .alert--neutral .alert__icon {
    color: var(--sl-color-neutral-600);
  }

  .alert--warning {
    border-top-color: var(--sl-color-warning-600);
  }

  .alert--warning .alert__icon {
    color: var(--sl-color-warning-600);
  }

  .alert--danger {
    border-top-color: var(--sl-color-danger-600);
  }

  .alert--danger .alert__icon {
    color: var(--sl-color-danger-600);
  }

  .alert__message {
    flex: 1 1 auto;
    display: block;
    padding: var(--sl-spacing-large);
    overflow: hidden;
  }

  .alert__close-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    font-size: var(--sl-font-size-medium);
    margin-inline-end: var(--sl-spacing-medium);
    align-self: center;
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: calc(var(--sl-panel-border-width) * 3);
    background-color: var(--sl-panel-border-color);
    display: flex;
  }

  .alert__countdown--ltr {
    justify-content: flex-end;
  }

  .alert__countdown .alert__countdown-elapsed {
    height: 100%;
    width: 0;
  }

  .alert--primary .alert__countdown-elapsed {
    background-color: var(--sl-color-primary-600);
  }

  .alert--success .alert__countdown-elapsed {
    background-color: var(--sl-color-success-600);
  }

  .alert--neutral .alert__countdown-elapsed {
    background-color: var(--sl-color-neutral-600);
  }

  .alert--warning .alert__countdown-elapsed {
    background-color: var(--sl-color-warning-600);
  }

  .alert--danger .alert__countdown-elapsed {
    background-color: var(--sl-color-danger-600);
  }

  .alert__timer {
    display: none;
  }
`;









var $a9af64a18e167ba2$var$_SlAlert = class _SlAlert extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.hasSlotController = new (0, $b1a011109453a5c6$export$34f6a5ffaa663541)(this, "icon", "suffix");
        this.localize = new (0, $10722e07903896cc$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.closable = false;
        this.variant = "primary";
        this.duration = Infinity;
        this.remainingTime = this.duration;
    }
    static get toastStack() {
        if (!this.currentToastStack) this.currentToastStack = Object.assign(document.createElement("div"), {
            className: "sl-toast-stack"
        });
        return this.currentToastStack;
    }
    firstUpdated() {
        this.base.hidden = !this.open;
    }
    restartAutoHide() {
        this.handleCountdownChange();
        clearTimeout(this.autoHideTimeout);
        clearInterval(this.remainingTimeInterval);
        if (this.open && this.duration < Infinity) {
            this.autoHideTimeout = window.setTimeout(()=>this.hide(), this.duration);
            this.remainingTime = this.duration;
            this.remainingTimeInterval = window.setInterval(()=>{
                this.remainingTime -= 100;
            }, 100);
        }
    }
    pauseAutoHide() {
        var _a;
        (_a = this.countdownAnimation) == null || _a.pause();
        clearTimeout(this.autoHideTimeout);
        clearInterval(this.remainingTimeInterval);
    }
    resumeAutoHide() {
        var _a;
        if (this.duration < Infinity) {
            this.autoHideTimeout = window.setTimeout(()=>this.hide(), this.remainingTime);
            this.remainingTimeInterval = window.setInterval(()=>{
                this.remainingTime -= 100;
            }, 100);
            (_a = this.countdownAnimation) == null || _a.play();
        }
    }
    handleCountdownChange() {
        if (this.open && this.duration < Infinity && this.countdown) {
            const { countdownElement: countdownElement } = this;
            const start = "100%";
            const end = "0";
            this.countdownAnimation = countdownElement.animate([
                {
                    width: start
                },
                {
                    width: end
                }
            ], {
                duration: this.duration,
                easing: "linear"
            });
        }
    }
    handleCloseClick() {
        this.hide();
    }
    async handleOpenChange() {
        if (this.open) {
            this.emit("sl-show");
            if (this.duration < Infinity) this.restartAutoHide();
            await (0, $e626354a2a01d7d8$export$ad12f740028ccbea)(this.base);
            this.base.hidden = false;
            const { keyframes: keyframes, options: options } = (0, $b575ae609e04e2cb$export$b1aed5dec0c2d368)(this, "alert.show", {
                dir: this.localize.dir()
            });
            await (0, $e626354a2a01d7d8$export$3b755839a54e1bb0)(this.base, keyframes, options);
            this.emit("sl-after-show");
        } else {
            (0, $5dc3a705384ed2e2$export$7868286b01c1cec2)(this);
            this.emit("sl-hide");
            clearTimeout(this.autoHideTimeout);
            clearInterval(this.remainingTimeInterval);
            await (0, $e626354a2a01d7d8$export$ad12f740028ccbea)(this.base);
            const { keyframes: keyframes, options: options } = (0, $b575ae609e04e2cb$export$b1aed5dec0c2d368)(this, "alert.hide", {
                dir: this.localize.dir()
            });
            await (0, $e626354a2a01d7d8$export$3b755839a54e1bb0)(this.base, keyframes, options);
            this.base.hidden = true;
            this.emit("sl-after-hide");
        }
    }
    handleDurationChange() {
        this.restartAutoHide();
    }
    /** Shows the alert. */ async show() {
        if (this.open) return void 0;
        this.open = true;
        return (0, $0d375bcca7290bcb$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the alert */ async hide() {
        if (!this.open) return void 0;
        this.open = false;
        return (0, $0d375bcca7290bcb$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    /**
   * Displays the alert as a toast notification. This will move the alert out of its position in the DOM and, when
   * dismissed, it will be removed from the DOM completely. By storing a reference to the alert, you can reuse it by
   * calling this method again. The returned promise will resolve after the alert is hidden.
   */ async toast() {
        return new Promise((resolve)=>{
            this.handleCountdownChange();
            if (_SlAlert.toastStack.parentElement === null) document.body.append(_SlAlert.toastStack);
            _SlAlert.toastStack.appendChild(this);
            requestAnimationFrame(()=>{
                this.clientWidth;
                this.show();
            });
            this.addEventListener("sl-after-hide", ()=>{
                _SlAlert.toastStack.removeChild(this);
                resolve();
                if (_SlAlert.toastStack.querySelector("sl-alert") === null) _SlAlert.toastStack.remove();
            }, {
                once: true
            });
        });
    }
    render() {
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
      <div
        part="base"
        class=${(0, $656efc25cab08857$export$56cc687933817664)({
            alert: true,
            "alert--open": this.open,
            "alert--closable": this.closable,
            "alert--has-countdown": !!this.countdown,
            "alert--has-icon": this.hasSlotController.test("icon"),
            "alert--primary": this.variant === "primary",
            "alert--success": this.variant === "success",
            "alert--neutral": this.variant === "neutral",
            "alert--warning": this.variant === "warning",
            "alert--danger": this.variant === "danger"
        })}
        role="alert"
        aria-hidden=${this.open ? "false" : "true"}
        @mouseenter=${this.pauseAutoHide}
        @mouseleave=${this.resumeAutoHide}
      >
        <div part="icon" class="alert__icon">
          <slot name="icon"></slot>
        </div>

        <div part="message" class="alert__message" aria-live="polite">
          <slot></slot>
        </div>

        ${this.closable ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
              <sl-icon-button
                part="close-button"
                exportparts="base:close-button__base"
                class="alert__close-button"
                name="x-lg"
                library="system"
                label=${this.localize.term("close")}
                @click=${this.handleCloseClick}
              ></sl-icon-button>
            ` : ""}

        <div role="timer" class="alert__timer">${this.remainingTime}</div>

        ${this.countdown ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
              <div
                class=${(0, $656efc25cab08857$export$56cc687933817664)({
            alert__countdown: true,
            "alert__countdown--ltr": this.countdown === "ltr"
        })}
              >
                <div class="alert__countdown-elapsed"></div>
              </div>
            ` : ""}
      </div>
    `;
    }
};
$a9af64a18e167ba2$var$_SlAlert.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $f180a0188ba4af37$export$1b79454e98b5adc7)
];
$a9af64a18e167ba2$var$_SlAlert.dependencies = {
    "sl-icon-button": (0, $f14a2a9dc31f5c78$export$302c9d29315a4659)
};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)('[part~="base"]')
], $a9af64a18e167ba2$var$_SlAlert.prototype, "base", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".alert__countdown-elapsed")
], $a9af64a18e167ba2$var$_SlAlert.prototype, "countdownElement", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "open", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "closable", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "variant", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Number
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "duration", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "countdown", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $a9af64a18e167ba2$var$_SlAlert.prototype, "remainingTime", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $a9af64a18e167ba2$var$_SlAlert.prototype, "handleOpenChange", 1);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("duration")
], $a9af64a18e167ba2$var$_SlAlert.prototype, "handleDurationChange", 1);
var $a9af64a18e167ba2$export$6e7c68d58861dcad = $a9af64a18e167ba2$var$_SlAlert;
(0, $b575ae609e04e2cb$export$6e92ecdbe15fda0b)("alert.show", {
    keyframes: [
        {
            opacity: 0,
            scale: 0.8
        },
        {
            opacity: 1,
            scale: 1
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});
(0, $b575ae609e04e2cb$export$6e92ecdbe15fda0b)("alert.hide", {
    keyframes: [
        {
            opacity: 1,
            scale: 1
        },
        {
            opacity: 0,
            scale: 0.8
        }
    ],
    options: {
        duration: 250,
        easing: "ease"
    }
});


// src/components/alert/alert.ts
var $121415ae6aa4b5ca$export$af26cf2d39cfc9d4 = (0, $a9af64a18e167ba2$export$6e7c68d58861dcad);
(0, $a9af64a18e167ba2$export$6e7c68d58861dcad).define("sl-alert");

























// src/components/details/details.styles.ts

var $a1ca28c8f70f2719$export$e0460a263d3b7bef = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .details {
    border: solid 1px var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-color-neutral-0);
    overflow-anchor: none;
  }

  .details--disabled {
    opacity: 0.5;
  }

  .details__header {
    display: flex;
    align-items: center;
    border-radius: inherit;
    padding: var(--sl-spacing-medium);
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
  }

  .details__header::-webkit-details-marker {
    display: none;
  }

  .details__header:focus {
    outline: none;
  }

  .details__header:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: calc(1px + var(--sl-focus-ring-offset));
  }

  .details--disabled .details__header {
    cursor: not-allowed;
  }

  .details--disabled .details__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .details__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .details__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
  }

  .details--open .details__summary-icon {
    rotate: 90deg;
  }

  .details--open.details--rtl .details__summary-icon {
    rotate: -90deg;
  }

  .details--open slot[name='expand-icon'],
  .details:not(.details--open) slot[name='collapse-icon'] {
    display: none;
  }

  .details__body {
    overflow: hidden;
  }

  .details__content {
    display: block;
    padding: var(--sl-spacing-medium);
  }
`;














var $1b749241728f862e$export$ada524cc60438dd5 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $10722e07903896cc$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.disabled = false;
    }
    firstUpdated() {
        this.body.style.height = this.open ? "auto" : "0";
        if (this.open) this.details.open = true;
        this.detailsObserver = new MutationObserver((changes)=>{
            for (const change of changes)if (change.type === "attributes" && change.attributeName === "open") {
                if (this.details.open) this.show();
                else this.hide();
            }
        });
        this.detailsObserver.observe(this.details, {
            attributes: true
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.detailsObserver) == null || _a.disconnect();
    }
    handleSummaryClick(event) {
        event.preventDefault();
        if (!this.disabled) {
            if (this.open) this.hide();
            else this.show();
            this.header.focus();
        }
    }
    handleSummaryKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (this.open) this.hide();
            else this.show();
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            event.preventDefault();
            this.hide();
        }
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            event.preventDefault();
            this.show();
        }
    }
    async handleOpenChange() {
        if (this.open) {
            this.details.open = true;
            const slShow = this.emit("sl-show", {
                cancelable: true
            });
            if (slShow.defaultPrevented) {
                this.open = false;
                this.details.open = false;
                return;
            }
            await (0, $e626354a2a01d7d8$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $b575ae609e04e2cb$export$b1aed5dec0c2d368)(this, "details.show", {
                dir: this.localize.dir()
            });
            await (0, $e626354a2a01d7d8$export$3b755839a54e1bb0)(this.body, (0, $e626354a2a01d7d8$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.emit("sl-after-show");
        } else {
            const slHide = this.emit("sl-hide", {
                cancelable: true
            });
            if (slHide.defaultPrevented) {
                this.details.open = true;
                this.open = true;
                return;
            }
            await (0, $e626354a2a01d7d8$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $b575ae609e04e2cb$export$b1aed5dec0c2d368)(this, "details.hide", {
                dir: this.localize.dir()
            });
            await (0, $e626354a2a01d7d8$export$3b755839a54e1bb0)(this.body, (0, $e626354a2a01d7d8$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.details.open = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the details. */ async show() {
        if (this.open || this.disabled) return void 0;
        this.open = true;
        return (0, $0d375bcca7290bcb$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the details */ async hide() {
        if (!this.open || this.disabled) return void 0;
        this.open = false;
        return (0, $0d375bcca7290bcb$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
      <details
        part="base"
        class=${(0, $656efc25cab08857$export$56cc687933817664)({
            details: true,
            "details--open": this.open,
            "details--disabled": this.disabled,
            "details--rtl": isRtl
        })}
      >
        <summary
          part="header"
          id="header"
          class="details__header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary" class="details__summary">${this.summary}</slot>

          <span part="summary-icon" class="details__summary-icon">
            <slot name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </span>
        </summary>

        <div class="details__body" role="region" aria-labelledby="header">
          <slot part="content" id="content" class="details__content"></slot>
        </div>
      </details>
    `;
    }
};
$1b749241728f862e$export$ada524cc60438dd5.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $a1ca28c8f70f2719$export$e0460a263d3b7bef)
];
$1b749241728f862e$export$ada524cc60438dd5.dependencies = {
    "sl-icon": (0, $9bfb3a1601ca18a8$export$ef62a86bf282441)
};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".details")
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "details", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".details__header")
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "header", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".details__body")
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "body", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".details__expand-icon-slot")
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "expandIconSlot", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "open", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "summary", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "disabled", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $1b749241728f862e$export$ada524cc60438dd5.prototype, "handleOpenChange", 1);
(0, $b575ae609e04e2cb$export$6e92ecdbe15fda0b)("details.show", {
    keyframes: [
        {
            height: "0",
            opacity: "0"
        },
        {
            height: "auto",
            opacity: "1"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});
(0, $b575ae609e04e2cb$export$6e92ecdbe15fda0b)("details.hide", {
    keyframes: [
        {
            height: "auto",
            opacity: "1"
        },
        {
            height: "0",
            opacity: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});


// src/components/details/details.ts
var $463efff09d8a2e07$export$991e1c3cf581681b = (0, $1b749241728f862e$export$ada524cc60438dd5);
(0, $1b749241728f862e$export$ada524cc60438dd5).define("sl-details");






















// src/components/icon-button/icon-button.ts
var $e1efd21e7cb7b9ba$export$9189df4c7423e03f = (0, $f14a2a9dc31f5c78$export$302c9d29315a4659);
(0, $f14a2a9dc31f5c78$export$302c9d29315a4659).define("sl-icon-button");






















const $73c248d429ceae66$var$PRIORITY_MEDIUM = 500;
const $73c248d429ceae66$var$PRIORITY_LOW = 200;
class $73c248d429ceae66$export$2d1b15b020192475 extends (0, $3209565c87346803$export$3f2f9f5909897157) {
    render() {
        if (this.error) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                <sl-alert variant="danger">
                    <strong>Error:</strong>
                    ${this.error}
                </sl-alert>`;
        if (!this.reading) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                <sl-alert variant="warning">
                    No reading data available.
                </sl-alert>`;
        const onDelete = ()=>this.deleteUrl(this.reading.url);
        const onNavigate = ()=>window.open(this.reading.url, "_blank");
        const latestPrice = this.reading.price;
        const medianPrice = this.reading.median_price;
        const isSale = latestPrice && latestPrice < medianPrice;
        const isSnoozed = this.reading.priority < $73c248d429ceae66$var$PRIORITY_MEDIUM;
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
            <sl-details class=${isSale && !isSnoozed ? "sale" : ""} @sl-show=${this.onDetailsShow}>
                <div slot="summary">
                    <sl-icon-button
                        name="trash"
                        label="Delete"
                        @click=${onDelete}>
                    </sl-icon-button>
                    <sl-icon-button
                        name=${isSnoozed ? "bell" : "moon"}
                        label=${isSnoozed ? "Unsnooze" : "Snooze"}
                        @click=${this.onSnoozeClick}>
                    </sl-icon-button>
                    <a href="${this.reading.url}" target="_blank">
                        ${this.reading?.title}
                        <sl-icon-button
                            name="box-arrow-up-right"
                            label="navigate to item"
                            @click=${onNavigate}>
                        </sl-icon-button>
                    </a>
                    <span>
                        Now: ${latestPrice?.toFixed(2) || "N/A"}
                    </span>
                    <span>
                        Median: ${medianPrice?.toFixed(2) || "N/A"}
                    </span>
                </div>
                <monitor-details-days .urlKey=${this.reading?.url_key}></monitor-details-days>
            </sl-details>`;
    }
    onDetailsShow() {
        if (this.detailsDaysComponent) this.detailsDaysComponent.loadReadings();
    }
    async onSnoozeClick(e) {
        e.stopPropagation();
        if (!this.reading) return;
        const isSnoozed = this.reading.priority < $73c248d429ceae66$var$PRIORITY_MEDIUM;
        const newPriority = isSnoozed ? $73c248d429ceae66$var$PRIORITY_MEDIUM : $73c248d429ceae66$var$PRIORITY_LOW;
        try {
            const response = await fetch("./data/setpriority", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    url: this.reading.url,
                    priority: newPriority
                })
            });
            if (!response.ok) {
                console.error("Failed to set priority:", response.statusText);
                return;
            }
            this.dispatchEvent(new CustomEvent("listing-priority-changed", {
                bubbles: true,
                composed: true
            }));
        } catch (error) {
            console.error("Failed to set priority:", error);
        }
    }
    async deleteUrl(target) {
        console.log("Deleting URL:", target);
        try {
            const response = await fetch("./data/removemonitor", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    url: target
                })
            });
            if (!response.ok) {
                const errorBody = await response.text();
                this.error = (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<strong>
                    <div>Failed to delete URL.</div>
                    <div>${response.status} ${response.statusText}</div>
                </strong>
                <div>${(0, $65c7cf7ae42ed665$export$b6e69390c23686fb)(errorBody)}</div>`;
                return;
            }
            // Mark as dirty to trigger reload in updated()
            this.reading = null;
        } catch (error) {
            console.error("Failed to delete URL:", error);
            this.error = (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<div>Failed to delete URL: ${String(error)}</div>`;
        }
    }
    static{
        this.styles = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
        sl-icon-button[name="trash"] {
            color: red;
        }

        sl-details div[slot="summary"] {
            display: flex;
            gap: 20px;
        }

         sl-details.sale::part(base) {
            text-decoration: underline;
            background-color: #fffde2;
         }
  `;
    }
    constructor(...args){
        super(...args), this.reading = null, this.error = null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Object
    })
], $73c248d429ceae66$export$2d1b15b020192475.prototype, "reading", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Object
    })
], $73c248d429ceae66$export$2d1b15b020192475.prototype, "error", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)("monitor-details-days")
], $73c248d429ceae66$export$2d1b15b020192475.prototype, "detailsDaysComponent", void 0);
$73c248d429ceae66$export$2d1b15b020192475 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $65c13613f7024f62$export$da64fc29f17f9d0e)("monitor-details")
], $73c248d429ceae66$export$2d1b15b020192475);
class $73c248d429ceae66$export$431a398a3b1a0c8d extends (0, $3209565c87346803$export$3f2f9f5909897157) {
    async loadReadings() {
        if (this.urlKey) this.readings = await this.fetchReadings(this.urlKey);
    }
    async fetchReadings(urlKey) {
        const response = await fetch(`./data/readinghistory/${encodeURIComponent(urlKey)}`);
        if (!response.ok) {
            console.error("Failed to fetch readings:", response.statusText);
            return [];
        }
        const data = await response.json();
        return data.readings;
    }
    render() {
        if (!this.urlKey) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<div>No URL</div>`;
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
            <table>
                <tr>
                    <th>Date</th>
                    <th>Reading</th>
                </tr>
                ${this.readings.map($73c248d429ceae66$var$renderDay)}
            </table>`;
    }
    static{
        this.styles = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
        table {
            border-collapse: separate;
            border-spacing: 0 12px;
            width: 100%;
        }

        tr {
            border-bottom: 1px solid #ddd;
        }

        tr:last-child {
            border-bottom: none;
        }

        td, th {
            padding: 8px 12px;
            text-align: left;
        }
  `;
    }
    constructor(...args){
        super(...args), this.urlKey = null, this.readings = [];
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: String
    })
], $73c248d429ceae66$export$431a398a3b1a0c8d.prototype, "urlKey", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $73c248d429ceae66$export$431a398a3b1a0c8d.prototype, "readings", void 0);
$73c248d429ceae66$export$431a398a3b1a0c8d = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $65c13613f7024f62$export$da64fc29f17f9d0e)("monitor-details-days")
], $73c248d429ceae66$export$431a398a3b1a0c8d);
function $73c248d429ceae66$var$renderDay(reading) {
    console.log("Rendering day:", reading.date.toString(), reading.price);
    const formattedDate = new Date(reading.date).toLocaleDateString();
    return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
        <tr>
            <td>
                ${formattedDate}
            </td>
            <td>
                ${reading.price?.toFixed(2)}
            </td>
            <td>
                <sl-icon-button
                    name="box-arrow-up-right"
                    label="Open screenshot"
                    @click=${()=>window.open(reading.screenshot_download, "_blank")}>
                </sl-icon-button>
            </td>
        </tr>
    `;
}


const $b6089f558bdfe2a3$var$PRIORITY_MEDIUM = 500;
class $b6089f558bdfe2a3$export$8f3cb8972a1180c1 extends (0, $3209565c87346803$export$3f2f9f5909897157) {
    constructor(){
        super(), this.data = null, this.error = null, this.dirty = false;
    }
    async loadData() {
        try {
            const response = await fetch("./data/monitoringoverview");
            if (!response.ok) {
                const errorBody = new DOMParser().parseFromString(await response.text(), "text/html").body.innerHTML;
                this.error = (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<strong>
                    <div>Data was not loaded.</div>
                    <div>${response.status} ${response.statusText}</div>
                </strong>
                <div>${(0, $65c7cf7ae42ed665$export$b6e69390c23686fb)(errorBody)}</div>`;
                return;
            }
            this.data = await response.json();
            this.error = null;
            console.log('data', JSON.stringify(this.data));
        } catch (error) {
            console.error("Failed to fetch data:", error);
            this.error = (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<div>Failed to fetch data: ${String(error)}</div>`;
        }
    }
    async firstUpdated() {
        await this.loadData();
        this.addEventListener("listing-priority-changed", async ()=>{
            await this.loadData();
        });
    }
    async updated(changedProps) {
        if (this.dirty) {
            await this.loadData();
            this.dirty = false;
        }
    }
    render() {
        if (this.error) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<sl-alert variant="warning" open>
                <sl-icon slot="icon" name="info-circle"></sl-icon>
                ${this.error}
            </sl-alert>`;
        if (!this.data) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<div>Loading...</div>`;
        const active = this.data.overview.filter((i)=>i.priority >= $b6089f558bdfe2a3$var$PRIORITY_MEDIUM);
        const snoozed = this.data.overview.filter((i)=>i.priority < $b6089f558bdfe2a3$var$PRIORITY_MEDIUM);
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
            ${active.map(this.renderUrlRow.bind(this))}
            ${snoozed.length > 0 ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                <sl-details class="snoozed-section">
                    <span slot="summary">Snoozed (${snoozed.length})</span>
                    ${snoozed.map(this.renderUrlRow.bind(this))}
                </sl-details>
            ` : ''}
        `;
    }
    renderUrlRow(data) {
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
            <monitor-details .reading="${data}">
            </monitor-details>
        `;
    }
    static{
        this.styles = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
        .snoozed-section {
            margin-top: 20px;
            opacity: 0.7;
        }
    `;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Object
    })
], $b6089f558bdfe2a3$export$8f3cb8972a1180c1.prototype, "data", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Object
    })
], $b6089f558bdfe2a3$export$8f3cb8972a1180c1.prototype, "error", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean
    })
], $b6089f558bdfe2a3$export$8f3cb8972a1180c1.prototype, "dirty", void 0);
$b6089f558bdfe2a3$export$8f3cb8972a1180c1 = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $65c13613f7024f62$export$da64fc29f17f9d0e)("url-widget")
], $b6089f558bdfe2a3$export$8f3cb8972a1180c1);


// src/components/spinner/spinner.styles.ts

var $ae14506d9b2399c9$export$6a9ed4d91972acb3 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    --track-width: 2px;
    --track-color: rgb(128 128 128 / 25%);
    --indicator-color: var(--sl-color-primary-600);
    --speed: 2s;

    display: inline-flex;
    width: 1em;
    height: 1em;
    flex: none;
  }

  .spinner {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
  }

  .spinner__track,
  .spinner__indicator {
    fill: none;
    stroke-width: var(--track-width);
    r: calc(0.5em - var(--track-width) / 2);
    cx: 0.5em;
    cy: 0.5em;
    transform-origin: 50% 50%;
  }

  .spinner__track {
    stroke: var(--track-color);
    transform-origin: 0% 0%;
  }

  .spinner__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    stroke-dasharray: 150% 75%;
    animation: spin var(--speed) linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
      stroke-dasharray: 0.05em, 3em;
    }

    50% {
      transform: rotate(450deg);
      stroke-dasharray: 1.375em, 1.375em;
    }

    100% {
      transform: rotate(1080deg);
      stroke-dasharray: 0.05em, 3em;
    }
  }
`;






var $25c790330abdea70$export$4e45ce56e46d2b00 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $10722e07903896cc$export$b1a2fed5bb41b893)(this);
    }
    render() {
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
      <svg part="base" class="spinner" role="progressbar" aria-label=${this.localize.term("loading")}>
        <circle class="spinner__track"></circle>
        <circle class="spinner__indicator"></circle>
      </svg>
    `;
    }
};
$25c790330abdea70$export$4e45ce56e46d2b00.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $ae14506d9b2399c9$export$6a9ed4d91972acb3)
];



// src/internal/form.ts
var $f21887985f6f6530$export$61a522b559454891 = /* @__PURE__ */ new WeakMap();
var $f21887985f6f6530$var$reportValidityOverloads = /* @__PURE__ */ new WeakMap();
var $f21887985f6f6530$var$checkValidityOverloads = /* @__PURE__ */ new WeakMap();
var $f21887985f6f6530$var$userInteractedControls = /* @__PURE__ */ new WeakSet();
var $f21887985f6f6530$var$interactions = /* @__PURE__ */ new WeakMap();
var $f21887985f6f6530$export$43da334182d34ab4 = class {
    constructor(host, options){
        this.handleFormData = (event)=>{
            const disabled = this.options.disabled(this.host);
            const name = this.options.name(this.host);
            const value = this.options.value(this.host);
            const isButton = this.host.tagName.toLowerCase() === "sl-button";
            if (this.host.isConnected && !disabled && !isButton && typeof name === "string" && name.length > 0 && typeof value !== "undefined") {
                if (Array.isArray(value)) value.forEach((val)=>{
                    event.formData.append(name, val.toString());
                });
                else event.formData.append(name, value.toString());
            }
        };
        this.handleFormSubmit = (event)=>{
            var _a;
            const disabled = this.options.disabled(this.host);
            const reportValidity = this.options.reportValidity;
            if (this.form && !this.form.noValidate) (_a = $f21887985f6f6530$export$61a522b559454891.get(this.form)) == null || _a.forEach((control)=>{
                this.setUserInteracted(control, true);
            });
            if (this.form && !this.form.noValidate && !disabled && !reportValidity(this.host)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        this.handleFormReset = ()=>{
            this.options.setValue(this.host, this.options.defaultValue(this.host));
            this.setUserInteracted(this.host, false);
            $f21887985f6f6530$var$interactions.set(this.host, []);
        };
        this.handleInteraction = (event)=>{
            const emittedEvents = $f21887985f6f6530$var$interactions.get(this.host);
            if (!emittedEvents.includes(event.type)) emittedEvents.push(event.type);
            if (emittedEvents.length === this.options.assumeInteractionOn.length) this.setUserInteracted(this.host, true);
        };
        this.checkFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.checkValidity === "function") {
                    if (!element.checkValidity()) return false;
                }
            }
            return true;
        };
        this.reportFormValidity = ()=>{
            if (this.form && !this.form.noValidate) {
                const elements = this.form.querySelectorAll("*");
                for (const element of elements)if (typeof element.reportValidity === "function") {
                    if (!element.reportValidity()) return false;
                }
            }
            return true;
        };
        (this.host = host).addController(this);
        this.options = (0, $0601f050124ece31$export$7de063a7aa429f6c)({
            form: (input)=>{
                const formId = input.form;
                if (formId) {
                    const root = input.getRootNode();
                    const form = root.querySelector(`#${formId}`);
                    if (form) return form;
                }
                return input.closest("form");
            },
            name: (input)=>input.name,
            value: (input)=>input.value,
            defaultValue: (input)=>input.defaultValue,
            disabled: (input)=>{
                var _a;
                return (_a = input.disabled) != null ? _a : false;
            },
            reportValidity: (input)=>typeof input.reportValidity === "function" ? input.reportValidity() : true,
            checkValidity: (input)=>typeof input.checkValidity === "function" ? input.checkValidity() : true,
            setValue: (input, value)=>input.value = value,
            assumeInteractionOn: [
                "sl-input"
            ]
        }, options);
    }
    hostConnected() {
        const form = this.options.form(this.host);
        if (form) this.attachForm(form);
        $f21887985f6f6530$var$interactions.set(this.host, []);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.addEventListener(event, this.handleInteraction);
        });
    }
    hostDisconnected() {
        this.detachForm();
        $f21887985f6f6530$var$interactions.delete(this.host);
        this.options.assumeInteractionOn.forEach((event)=>{
            this.host.removeEventListener(event, this.handleInteraction);
        });
    }
    hostUpdated() {
        const form = this.options.form(this.host);
        if (!form) this.detachForm();
        if (form && this.form !== form) {
            this.detachForm();
            this.attachForm(form);
        }
        if (this.host.hasUpdated) this.setValidity(this.host.validity.valid);
    }
    attachForm(form) {
        if (form) {
            this.form = form;
            if ($f21887985f6f6530$export$61a522b559454891.has(this.form)) $f21887985f6f6530$export$61a522b559454891.get(this.form).add(this.host);
            else $f21887985f6f6530$export$61a522b559454891.set(this.form, /* @__PURE__ */ new Set([
                this.host
            ]));
            this.form.addEventListener("formdata", this.handleFormData);
            this.form.addEventListener("submit", this.handleFormSubmit);
            this.form.addEventListener("reset", this.handleFormReset);
            if (!$f21887985f6f6530$var$reportValidityOverloads.has(this.form)) {
                $f21887985f6f6530$var$reportValidityOverloads.set(this.form, this.form.reportValidity);
                this.form.reportValidity = ()=>this.reportFormValidity();
            }
            if (!$f21887985f6f6530$var$checkValidityOverloads.has(this.form)) {
                $f21887985f6f6530$var$checkValidityOverloads.set(this.form, this.form.checkValidity);
                this.form.checkValidity = ()=>this.checkFormValidity();
            }
        } else this.form = void 0;
    }
    detachForm() {
        if (!this.form) return;
        const formCollection = $f21887985f6f6530$export$61a522b559454891.get(this.form);
        if (!formCollection) return;
        formCollection.delete(this.host);
        if (formCollection.size <= 0) {
            this.form.removeEventListener("formdata", this.handleFormData);
            this.form.removeEventListener("submit", this.handleFormSubmit);
            this.form.removeEventListener("reset", this.handleFormReset);
            if ($f21887985f6f6530$var$reportValidityOverloads.has(this.form)) {
                this.form.reportValidity = $f21887985f6f6530$var$reportValidityOverloads.get(this.form);
                $f21887985f6f6530$var$reportValidityOverloads.delete(this.form);
            }
            if ($f21887985f6f6530$var$checkValidityOverloads.has(this.form)) {
                this.form.checkValidity = $f21887985f6f6530$var$checkValidityOverloads.get(this.form);
                $f21887985f6f6530$var$checkValidityOverloads.delete(this.form);
            }
            this.form = void 0;
        }
    }
    setUserInteracted(el, hasInteracted) {
        if (hasInteracted) $f21887985f6f6530$var$userInteractedControls.add(el);
        else $f21887985f6f6530$var$userInteractedControls.delete(el);
        el.requestUpdate();
    }
    doAction(type, submitter) {
        if (this.form) {
            const button = document.createElement("button");
            button.type = type;
            button.style.position = "absolute";
            button.style.width = "0";
            button.style.height = "0";
            button.style.clipPath = "inset(50%)";
            button.style.overflow = "hidden";
            button.style.whiteSpace = "nowrap";
            if (submitter) {
                button.name = submitter.name;
                button.value = submitter.value;
                [
                    "formaction",
                    "formenctype",
                    "formmethod",
                    "formnovalidate",
                    "formtarget"
                ].forEach((attr)=>{
                    if (submitter.hasAttribute(attr)) button.setAttribute(attr, submitter.getAttribute(attr));
                });
            }
            this.form.append(button);
            button.click();
            button.remove();
        }
    }
    /** Returns the associated `<form>` element, if one exists. */ getForm() {
        var _a;
        return (_a = this.form) != null ? _a : null;
    }
    /** Resets the form, restoring all the control to their default value */ reset(submitter) {
        this.doAction("reset", submitter);
    }
    /** Submits the form, triggering validation and form data injection. */ submit(submitter) {
        this.doAction("submit", submitter);
    }
    /**
   * Synchronously sets the form control's validity. Call this when you know the future validity but need to update
   * the host element immediately, i.e. before Lit updates the component in the next update.
   */ setValidity(isValid) {
        const host = this.host;
        const hasInteracted = Boolean($f21887985f6f6530$var$userInteractedControls.has(host));
        const required = Boolean(host.required);
        host.toggleAttribute("data-required", required);
        host.toggleAttribute("data-optional", !required);
        host.toggleAttribute("data-invalid", !isValid);
        host.toggleAttribute("data-valid", isValid);
        host.toggleAttribute("data-user-invalid", !isValid && hasInteracted);
        host.toggleAttribute("data-user-valid", isValid && hasInteracted);
    }
    /**
   * Updates the form control's validity based on the current value of `host.validity.valid`. Call this when anything
   * that affects constraint validation changes so the component receives the correct validity states.
   */ updateValidity() {
        const host = this.host;
        this.setValidity(host.validity.valid);
    }
    /**
   * Dispatches a non-bubbling, cancelable custom event of type `sl-invalid`.
   * If the `sl-invalid` event will be cancelled then the original `invalid`
   * event (which may have been passed as argument) will also be cancelled.
   * If no original `invalid` event has been passed then the `sl-invalid`
   * event will be cancelled before being dispatched.
   */ emitInvalidEvent(originalInvalidEvent) {
        const slInvalidEvent = new CustomEvent("sl-invalid", {
            bubbles: false,
            composed: false,
            cancelable: true,
            detail: {}
        });
        if (!originalInvalidEvent) slInvalidEvent.preventDefault();
        if (!this.host.dispatchEvent(slInvalidEvent)) originalInvalidEvent == null || originalInvalidEvent.preventDefault();
    }
};
var $f21887985f6f6530$export$6c5960ddf0f5ff89 = Object.freeze({
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: true,
    valueMissing: false
});
var $f21887985f6f6530$export$bd584164a4d1886c = Object.freeze((0, $0601f050124ece31$export$f4da8f157c1253f7)((0, $0601f050124ece31$export$7de063a7aa429f6c)({}, $f21887985f6f6530$export$6c5960ddf0f5ff89), {
    valid: false,
    valueMissing: true
}));
var $f21887985f6f6530$export$d17679f2bc5863d4 = Object.freeze((0, $0601f050124ece31$export$f4da8f157c1253f7)((0, $0601f050124ece31$export$7de063a7aa429f6c)({}, $f21887985f6f6530$export$6c5960ddf0f5ff89), {
    valid: false,
    customError: true
}));


// src/components/button/button.styles.ts

var $3bab3d246bdc9a6d$export$172eea9c07ee1ffd = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`;













var $482a81204e366077$export$e56d306ebf763f31 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $f21887985f6f6530$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "click"
            ]
        });
        this.hasSlotController = new (0, $b1a011109453a5c6$export$34f6a5ffaa663541)(this, "[default]", "prefix", "suffix");
        this.localize = new (0, $10722e07903896cc$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.invalid = false;
        this.title = "";
        this.variant = "default";
        this.size = "medium";
        this.caret = false;
        this.disabled = false;
        this.loading = false;
        this.outline = false;
        this.pill = false;
        this.circle = false;
        this.type = "button";
        this.name = "";
        this.value = "";
        this.href = "";
        this.rel = "noreferrer noopener";
    }
    /** Gets the validity state object */ get validity() {
        if (this.isButton()) return this.button.validity;
        return 0, $f21887985f6f6530$export$6c5960ddf0f5ff89;
    }
    /** Gets the validation message */ get validationMessage() {
        if (this.isButton()) return this.button.validationMessage;
        return "";
    }
    firstUpdated() {
        if (this.isButton()) this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleClick() {
        if (this.type === "submit") this.formControlController.submit(this);
        if (this.type === "reset") this.formControlController.reset(this);
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    isButton() {
        return this.href ? false : true;
    }
    isLink() {
        return this.href ? true : false;
    }
    handleDisabledChange() {
        if (this.isButton()) this.formControlController.setValidity(this.disabled);
    }
    /** Simulates a click on the button. */ click() {
        this.button.click();
    }
    /** Sets focus on the button. */ focus(options) {
        this.button.focus(options);
    }
    /** Removes focus from the button. */ blur() {
        this.button.blur();
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        if (this.isButton()) return this.button.checkValidity();
        return true;
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        if (this.isButton()) return this.button.reportValidity();
        return true;
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        if (this.isButton()) {
            this.button.setCustomValidity(message);
            this.formControlController.updateValidity();
        }
    }
    render() {
        const isLink = this.isLink();
        const tag = isLink ? (0, $83633668d38fc0ea$export$c8ec6e1ec9fefcb0)`a` : (0, $83633668d38fc0ea$export$c8ec6e1ec9fefcb0)`button`;
        return (0, $83633668d38fc0ea$export$c0bb0b647f701bb5)`
      <${tag}
        part="base"
        class=${(0, $656efc25cab08857$export$56cc687933817664)({
            button: true,
            "button--default": this.variant === "default",
            "button--primary": this.variant === "primary",
            "button--success": this.variant === "success",
            "button--neutral": this.variant === "neutral",
            "button--warning": this.variant === "warning",
            "button--danger": this.variant === "danger",
            "button--text": this.variant === "text",
            "button--small": this.size === "small",
            "button--medium": this.size === "medium",
            "button--large": this.size === "large",
            "button--caret": this.caret,
            "button--circle": this.circle,
            "button--disabled": this.disabled,
            "button--focused": this.hasFocus,
            "button--loading": this.loading,
            "button--standard": !this.outline,
            "button--outline": this.outline,
            "button--pill": this.pill,
            "button--rtl": this.localize.dir() === "rtl",
            "button--has-label": this.hasSlotController.test("[default]"),
            "button--has-prefix": this.hasSlotController.test("prefix"),
            "button--has-suffix": this.hasSlotController.test("suffix")
        })}
        ?disabled=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : this.disabled)}
        type=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : this.type)}
        title=${this.title}
        name=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : this.name)}
        value=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : this.value)}
        href=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink && !this.disabled ? this.href : void 0)}
        target=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.target : void 0)}
        download=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.download : void 0)}
        rel=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? this.rel : void 0)}
        role=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(isLink ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? (0, $83633668d38fc0ea$export$c0bb0b647f701bb5)` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? (0, $83633668d38fc0ea$export$c0bb0b647f701bb5)`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${tag}>
    `;
    }
};
$482a81204e366077$export$e56d306ebf763f31.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $3bab3d246bdc9a6d$export$172eea9c07ee1ffd)
];
$482a81204e366077$export$e56d306ebf763f31.dependencies = {
    "sl-icon": (0, $9bfb3a1601ca18a8$export$ef62a86bf282441),
    "sl-spinner": (0, $25c790330abdea70$export$4e45ce56e46d2b00)
};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".button")
], $482a81204e366077$export$e56d306ebf763f31.prototype, "button", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "hasFocus", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "invalid", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "title", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "variant", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "size", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "caret", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "disabled", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "loading", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "outline", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "pill", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "circle", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "type", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "name", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "value", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "href", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "target", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "rel", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "download", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $482a81204e366077$export$e56d306ebf763f31.prototype, "form", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "formaction"
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "formAction", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "formenctype"
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "formEnctype", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "formmethod"
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "formMethod", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "formnovalidate",
        type: Boolean
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "formNoValidate", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "formtarget"
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "formTarget", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $482a81204e366077$export$e56d306ebf763f31.prototype, "handleDisabledChange", 1);


// src/components/button/button.ts
var $a75edc6705f62e6a$export$11c362adf4e83e40 = (0, $482a81204e366077$export$e56d306ebf763f31);
(0, $482a81204e366077$export$e56d306ebf763f31).define("sl-button");






















// src/components/input/input.styles.ts

var $e891e14f6dec52aa$export$c3b7146590bd78c8 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`;


// src/internal/default-value.ts

var $f0c405e0abab3504$export$1a01ae0705bafd37 = (propertyName = "value")=>(proto, key)=>{
        const ctor = proto.constructor;
        const attributeChangedCallback = ctor.prototype.attributeChangedCallback;
        ctor.prototype.attributeChangedCallback = function(name, old, value) {
            var _a;
            const options = ctor.getPropertyOptions(propertyName);
            const attributeName = typeof options.attribute === "string" ? options.attribute : propertyName;
            if (name === attributeName) {
                const converter = options.converter || (0, $5861e07b888ab170$export$7312b35fbf521afb);
                const fromAttribute = typeof converter === "function" ? converter : (_a = converter == null ? void 0 : converter.fromAttribute) != null ? _a : (0, $5861e07b888ab170$export$7312b35fbf521afb).fromAttribute;
                const newValue = fromAttribute(value, options.type);
                if (this[propertyName] !== newValue) this[key] = newValue;
            }
            attributeChangedCallback.call(this, name, old, value);
        };
    };


// src/styles/form-control.styles.ts

var $db01c536a4e6b8d9$export$e7c8528c268605e9 = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
  .form-control .form-control__label {
    display: none;
  }

  .form-control .form-control__help-text {
    display: none;
  }

  /* Label */
  .form-control--has-label .form-control__label {
    display: inline-block;
    color: var(--sl-input-label-color);
    margin-bottom: var(--sl-spacing-3x-small);
  }

  .form-control--has-label.form-control--small .form-control__label {
    font-size: var(--sl-input-label-font-size-small);
  }

  .form-control--has-label.form-control--medium .form-control__label {
    font-size: var(--sl-input-label-font-size-medium);
  }

  .form-control--has-label.form-control--large .form-control__label {
    font-size: var(--sl-input-label-font-size-large);
  }

  :host([required]) .form-control--has-label .form-control__label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
  }

  /* Help text */
  .form-control--has-help-text .form-control__help-text {
    display: block;
    color: var(--sl-input-help-text-color);
    margin-top: var(--sl-spacing-3x-small);
  }

  .form-control--has-help-text.form-control--small .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-small);
  }

  .form-control--has-help-text.form-control--medium .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-medium);
  }

  .form-control--has-help-text.form-control--large .form-control__help-text {
    font-size: var(--sl-input-help-text-font-size-large);
  }

  .form-control--has-help-text.form-control--radio-group .form-control__help-text {
    margin-top: var(--sl-spacing-2x-small);
  }
`;
















/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f7ac85c7c07a1f1e$export$28cf49ad70f82d12 = (0, $b21739933ed75606$export$99b43ad1ed32e735)(class extends (0, $b21739933ed75606$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $b21739933ed75606$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $b21739933ed75606$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $b21739933ed75606$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $a4dbc275fd3b7fe1$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8) || t === (0, $8ca6ebe8d46dfd5b$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $b21739933ed75606$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $b21739933ed75606$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $b21739933ed75606$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $8ca6ebe8d46dfd5b$export$9c068ae9cc5db4e8;
        return (0, $a4dbc275fd3b7fe1$export$ea70d9dd5965b1c8)(i), t;
    }
});





var $5321bba573f95bc1$export$bf759620d4db2643 = class extends (0, $cac6099631212a0e$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.formControlController = new (0, $f21887985f6f6530$export$43da334182d34ab4)(this, {
            assumeInteractionOn: [
                "sl-blur",
                "sl-input"
            ]
        });
        this.hasSlotController = new (0, $b1a011109453a5c6$export$34f6a5ffaa663541)(this, "help-text", "label");
        this.localize = new (0, $10722e07903896cc$export$b1a2fed5bb41b893)(this);
        this.hasFocus = false;
        this.title = "";
        // make reactive to pass through
        this.__numberInput = Object.assign(document.createElement("input"), {
            type: "number"
        });
        this.__dateInput = Object.assign(document.createElement("input"), {
            type: "date"
        });
        this.type = "text";
        this.name = "";
        this.value = "";
        this.defaultValue = "";
        this.size = "medium";
        this.filled = false;
        this.pill = false;
        this.label = "";
        this.helpText = "";
        this.clearable = false;
        this.disabled = false;
        this.placeholder = "";
        this.readonly = false;
        this.passwordToggle = false;
        this.passwordVisible = false;
        this.noSpinButtons = false;
        this.form = "";
        this.required = false;
        this.spellcheck = true;
    }
    //
    // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
    // can be set before the component is rendered.
    //
    /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */ get valueAsDate() {
        var _a;
        this.__dateInput.type = this.type;
        this.__dateInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsDate) || this.__dateInput.valueAsDate;
    }
    set valueAsDate(newValue) {
        this.__dateInput.type = this.type;
        this.__dateInput.valueAsDate = newValue;
        this.value = this.__dateInput.value;
    }
    /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */ get valueAsNumber() {
        var _a;
        this.__numberInput.value = this.value;
        return ((_a = this.input) == null ? void 0 : _a.valueAsNumber) || this.__numberInput.valueAsNumber;
    }
    set valueAsNumber(newValue) {
        this.__numberInput.valueAsNumber = newValue;
        this.value = this.__numberInput.value;
    }
    /** Gets the validity state object */ get validity() {
        return this.input.validity;
    }
    /** Gets the validation message */ get validationMessage() {
        return this.input.validationMessage;
    }
    firstUpdated() {
        this.formControlController.updateValidity();
    }
    handleBlur() {
        this.hasFocus = false;
        this.emit("sl-blur");
    }
    handleChange() {
        this.value = this.input.value;
        this.emit("sl-change");
    }
    handleClearClick(event) {
        event.preventDefault();
        if (this.value !== "") {
            this.value = "";
            this.emit("sl-clear");
            this.emit("sl-input");
            this.emit("sl-change");
        }
        this.input.focus();
    }
    handleFocus() {
        this.hasFocus = true;
        this.emit("sl-focus");
    }
    handleInput() {
        this.value = this.input.value;
        this.formControlController.updateValidity();
        this.emit("sl-input");
    }
    handleInvalid(event) {
        this.formControlController.setValidity(false);
        this.formControlController.emitInvalidEvent(event);
    }
    handleKeyDown(event) {
        const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        if (event.key === "Enter" && !hasModifier) setTimeout(()=>{
            if (!event.defaultPrevented && !event.isComposing) this.formControlController.submit();
        });
    }
    handlePasswordToggle() {
        this.passwordVisible = !this.passwordVisible;
    }
    handleDisabledChange() {
        this.formControlController.setValidity(this.disabled);
    }
    handleStepChange() {
        this.input.step = String(this.step);
        this.formControlController.updateValidity();
    }
    async handleValueChange() {
        await this.updateComplete;
        this.formControlController.updateValidity();
    }
    /** Sets focus on the input. */ focus(options) {
        this.input.focus(options);
    }
    /** Removes focus from the input. */ blur() {
        this.input.blur();
    }
    /** Selects all the text in the input. */ select() {
        this.input.select();
    }
    /** Sets the start and end positions of the text selection (0-based). */ setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
        this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    /** Replaces a range of text with a new string. */ setRangeText(replacement, start, end, selectMode = "preserve") {
        const selectionStart = start != null ? start : this.input.selectionStart;
        const selectionEnd = end != null ? end : this.input.selectionEnd;
        this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */ showPicker() {
        if ("showPicker" in HTMLInputElement.prototype) this.input.showPicker();
    }
    /** Increments the value of a numeric input type by the value of the step attribute. */ stepUp() {
        this.input.stepUp();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Decrements the value of a numeric input type by the value of the step attribute. */ stepDown() {
        this.input.stepDown();
        if (this.value !== this.input.value) this.value = this.input.value;
    }
    /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */ checkValidity() {
        return this.input.checkValidity();
    }
    /** Gets the associated form, if one exists. */ getForm() {
        return this.formControlController.getForm();
    }
    /** Checks for validity and shows the browser's validation message if the control is invalid. */ reportValidity() {
        return this.input.reportValidity();
    }
    /** Sets a custom validation message. Pass an empty string to restore validity. */ setCustomValidity(message) {
        this.input.setCustomValidity(message);
        this.formControlController.updateValidity();
    }
    render() {
        const hasLabelSlot = this.hasSlotController.test("label");
        const hasHelpTextSlot = this.hasSlotController.test("help-text");
        const hasLabel = this.label ? true : !!hasLabelSlot;
        const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
        const hasClearIcon = this.clearable && !this.disabled && !this.readonly;
        const isClearIconVisible = hasClearIcon && (typeof this.value === "number" || this.value.length > 0);
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
      <div
        part="form-control"
        class=${(0, $656efc25cab08857$export$56cc687933817664)({
            "form-control": true,
            "form-control--small": this.size === "small",
            "form-control--medium": this.size === "medium",
            "form-control--large": this.size === "large",
            "form-control--has-label": hasLabel,
            "form-control--has-help-text": hasHelpText
        })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${hasLabel ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${(0, $656efc25cab08857$export$56cc687933817664)({
            input: true,
            // Sizes
            "input--small": this.size === "small",
            "input--medium": this.size === "medium",
            "input--large": this.size === "large",
            // States
            "input--pill": this.pill,
            "input--standard": !this.filled,
            "input--filled": this.filled,
            "input--disabled": this.disabled,
            "input--focused": this.hasFocus,
            "input--empty": !this.value,
            "input--no-spin-buttons": this.noSpinButtons
        })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.placeholder)}
              minlength=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.minlength)}
              maxlength=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.maxlength)}
              min=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.min)}
              max=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.max)}
              step=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.step)}
              .value=${(0, $f7ac85c7c07a1f1e$export$28cf49ad70f82d12)(this.value)}
              autocapitalize=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.autocapitalize)}
              autocomplete=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.autocomplete)}
              autocorrect=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.pattern)}
              enterkeyhint=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.enterkeyhint)}
              inputmode=${(0, $a2e23e237c51b1eb$export$f68dd208b5df064d)(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${isClearIconVisible ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${hasHelpText ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
    }
};
$5321bba573f95bc1$export$bf759620d4db2643.styles = [
    (0, $264a52ab16055a3e$export$e1ac0a3ec62d1269),
    (0, $db01c536a4e6b8d9$export$e7c8528c268605e9),
    (0, $e891e14f6dec52aa$export$c3b7146590bd78c8)
];
$5321bba573f95bc1$export$bf759620d4db2643.dependencies = {
    "sl-icon": (0, $9bfb3a1601ca18a8$export$ef62a86bf282441)
};
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $e95fa7940ac4d749$export$2fa187e846a241c4)(".input__control")
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "input", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $3bd90e28f73d76df$export$ca000e230c0caa3e)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "hasFocus", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "title", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "type", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "name", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "value", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $f0c405e0abab3504$export$1a01ae0705bafd37)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "defaultValue", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "size", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "filled", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "pill", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "label", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "help-text"
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "helpText", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "clearable", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "disabled", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "placeholder", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "readonly", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "password-toggle",
        type: Boolean
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "passwordToggle", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "password-visible",
        type: Boolean
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "passwordVisible", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        attribute: "no-spin-buttons",
        type: Boolean
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "noSpinButtons", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "form", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "required", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "pattern", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Number
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "minlength", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Number
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "maxlength", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "min", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "max", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "step", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "autocapitalize", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "autocorrect", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "autocomplete", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "autofocus", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "enterkeyhint", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Boolean,
        converter: {
            // Allow "true|false" attribute values but keep the property boolean
            fromAttribute: (value)=>!value || value === "false" ? false : true,
            toAttribute: (value)=>value ? "true" : "false"
        }
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "spellcheck", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)()
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "inputmode", 2);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("disabled", {
        waitUntilFirstUpdate: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "handleDisabledChange", 1);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("step", {
        waitUntilFirstUpdate: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "handleStepChange", 1);
(0, $0601f050124ece31$export$85c93885f16e8446)([
    (0, $350307ebc9093410$export$3db5d71bdb2d5499)("value", {
        waitUntilFirstUpdate: true
    })
], $5321bba573f95bc1$export$bf759620d4db2643.prototype, "handleValueChange", 1);


// src/components/input/input.ts
var $918bde82fd0c2fa0$export$921a3451e53aa4ce = (0, $5321bba573f95bc1$export$bf759620d4db2643);
(0, $5321bba573f95bc1$export$bf759620d4db2643).define("sl-input");






















class $f55196f066afa407$export$c06e9b40b0d02ca extends (0, $3209565c87346803$export$3f2f9f5909897157) {
    constructor(){
        super(), this.data = null;
    }
    async firstUpdated() {
        try {
            const response = await fetch("./status");
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            this.data = await response.json();
        } catch (error) {
            console.error("Failed to fetch data:", error);
        }
    }
    render() {
        if (!this.data) return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`<div>Loading...</div>`;
        return (0, $8ca6ebe8d46dfd5b$export$c0bb0b647f701bb5)`
            <sl-alert open closable>
                <sl-icon slot="icon" name="info-circle"></sl-icon>
                ${this.data["status"]} ${this.data["version"]}
            </sl-alert>

            <url-widget></url-widget>

            <div id="addUrlSection">
                <sl-input id="inputUrl" type="url" placeholder="Enter url here" style="width: 100%;">
                    <sl-icon name="globe" slot="prefix"></sl-icon>
                </sl-input>
                <sl-button size="small" @click=${this.onAddClick} style="margin-top: 10px;">
                    <sl-icon name="plus" slot="prefix"></sl-icon>
                    Add
                </sl-button>
            </div>
        `;
    }
    onAddClick() {
        const inputElement = this.shadowRoot?.querySelector("#inputUrl");
        if (inputElement) {
            let url = inputElement.value.trim();
            if (url && !url.startsWith("http://") && !url.startsWith("https://")) url = `http://${url}`;
            console.log("Formatted URL:", url);
            // Add your logic here to handle the formatted URL
            fetch("./data/addmonitor", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    url: url
                })
            }).then((response)=>{
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            }).then((data)=>{
                console.log("Successfully added URL:", data);
                inputElement.value = ""; // Clear the input field
            }).catch((error)=>{
                console.error("Failed to add URL:", error);
            });
        }
    }
    static{
        this.styles = (0, $242210c2ae8f94f6$export$dbf350e5966cf602)`
        sl-input#inputUrl {
            min-width: 150px;
            max-width: 50%;
        }

        #addUrlSection {
            margin: 20px 10px;
        }

        sl-alert[open] {
            margin: 10px;
        }
    `;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $0c8d6c23f421d782$export$d541bacb2bda4494)({
        type: Object
    })
], $f55196f066afa407$export$c06e9b40b0d02ca.prototype, "data", void 0);
$f55196f066afa407$export$c06e9b40b0d02ca = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $65c13613f7024f62$export$da64fc29f17f9d0e)("root-element")
], $f55196f066afa407$export$c06e9b40b0d02ca);











(0, $e46fbc9fac217803$export$a482e04ad60c9b11)('default', {
    resolver: (name)=>`https://cdn.jsdelivr.net/npm/bootstrap-icons@1.0.0/icons/${name}.svg`
});


//# sourceMappingURL=static.5c8aec04.js.map
